// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminAlgolia = (client) => ({
    /**
     * `POST /admin/algolia`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSyncAlgolia
     * @source packages/modules/algolia/src/api/admin/algolia/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/algolia", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/algolia/products`
     *
     * @operationId AdminSyncAlgoliaProducts
     * @source packages/modules/algolia/src/api/admin/algolia/products/route.ts
     */
    createProduct: (body, query, headers) => client.fetch("/admin/algolia/products", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/algolia`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetAlgoliaStatus
     * @source packages/modules/algolia/src/api/admin/algolia/route.ts
     */
    list: (query, headers) => client.fetch("/admin/algolia", { method: "GET", query, headers }),
    /**
     * `GET /admin/algolia/products`
     *
     * @operationId AdminGetAlgoliaProductStatus
     * @source packages/modules/algolia/src/api/admin/algolia/products/route.ts
     */
    listProducts: (query, headers) => client.fetch("/admin/algolia/products", { method: "GET", query, headers }),
});
//# sourceMappingURL=algolia.js.map